window.loadedSentryIntegrations = window.loadedSentryIntegrations || [];


function filterAlreadyLoadedIntegrations(wantedIntegrations) {
  const result = [];
  for (const integration of (wantedIntegrations || [])) {
	if (!window.loadedSentryIntegrations.includes(integration.name)) {
	  window.loadedSentryIntegrations.push(integration.name);
	  result.push(integration);
	}
  }
  return result;
}


export default function getSentryConfig(Sentry) {
  const wantedIntegrations = [
	Sentry.browserTracingIntegration(),
	Sentry.extraErrorDataIntegration(),
	// Sentry.replayIntegration(),
  ];
  const dropUrls = [
    /recaptcha/i,
    /crazyegg\.com/i,
    /script\.crazyegg\.com/i,
    /\/pages\/versioned\/.*scripts\//i,  // NOTE: CrazyEgg's path pattern (domain may be stripped if cross-domain)
    /freshchat/i,
    /bglinks/i,
    /widget\.js/i,
  ];
  const dropModules = [
	/^plyr/i,
	/^recaptcha/i,
  ];
  const config = {
	dsn: window.SENTRY_DSN,
	attachStacktrace: true,
	normalizeDepth: 8,
	environment: window.ENVIRONMENT,
	allowUrls: [
      new RegExp(`${window.location.origin}/`, "i"),
      new RegExp(`${window.STATIC_URL}`, "i"),
	],
	ignoreErrors: [
	  "Invalid site key or not loaded",
	  /^recaptcha/i,
	  /Can't find variable: gmo$/i,
	  "Java exception was raised during method invocation",
	  /Java object is gone$/i,
	  "Non-Error promise rejection captured",
	  "Object Not Found Matching Id",
      "ResizeObserver loop limit exceeded",
	  /window\.webkit\.messageHandlers/i,
	  /window.__firefox__.reader/,
	  /evaluating 'window.webkit.messageHandlers'/,
	],
	tracesSampleRate: window.SENTRY_TRACE_SAMPLE_RATE || 1.0,
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: window.SENTRY_SAMPLE_RATE,
	beforeSend(event) {
	  try {
		const frames = event?.exception?.values?.[0]?.stacktrace?.frames || [];
		if (frames.length) {
		  const lastFrame = frames.at(-1);
		  // NOTE: abs_path may be lacking the domain, check filename too
		  const urlToCheck = lastFrame.abs_path || lastFrame.filename || '';
		  if (dropUrls.some(pattern => pattern.test(urlToCheck))) {
			return null;
		  }
		  if (dropModules.some(pattern => pattern.test(lastFrame.module))) {
			return null;
		  }
		}
	  } catch (err) {
		console.error("Error in beforeSend filter", err);
	  }
	  return event;
	}
  };
  if (window.SITE_SENTRY_RELEASE) {
	config.release = window.SITE_SENTRY_RELEASE;
  }
  return config;
}
